import { Menu, MenuItem } from '@material-ui/core';
import i18next from 'i18next';
import React, { useState } from 'react';
import { track } from '~/src/dash/analytics/analytics';

import { IconTextButton } from '~/src/dash/components/buttons/IconTextButton';
import { useBaseStore } from '~/src/dash/views/base/contexts';

interface ILanguageOption {
  value: string;
  label: string;
}

const languages: ILanguageOption[] = [
  { value: 'en', label: 'English' },
  { value: 'ja', label: '日本語 (JP)' },
];

export const LanguageMenu = (): React.JSX.Element => {
  const { isSuperUser, user } = useBaseStore();
  const [anchorEl, setAnchorEl] = useState<HTMLElement | undefined>(undefined);

  const onMenuClick = ({ currentTarget }: React.MouseEvent<HTMLElement>): void => {
    setAnchorEl(currentTarget);
  };

  const onMenuClose = (): void => {
    setAnchorEl(undefined);
  };

  return (
    <>
      <IconTextButton
        // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
        handleOnClick={(e: React.MouseEvent<HTMLElement>) => onMenuClick(e)}
        iconSlug='globe_small'
        tooltipTKey='Language'
      />
      <Menu anchorEl={anchorEl} open={!!anchorEl} onClose={onMenuClose}>
        {languages.map((language) => (
          <MenuItem
            key={language.value}
            selected={language.value === i18next.language}
            onClick={() => {
              void i18next.changeLanguage(language.value);
              track('Language Switch', { isSuperUser, language: language.value }, user.user);
              onMenuClose();
              window.location.reload(); // force reload to apply language changes to class components
              // Note: This is a workaround since class components do not automatically re-render on language change.
            }}
          >
            {language.label}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};
